import {
    GET_MERCHANT_USED_SCHEME_FAILED, GET_MERCHANT_USED_SCHEME_LOADING, REMOVE_MERCHANT_USED_SCHEME, GET_MERCHANT_USED_SCHEME_SUCCESS
} from "../types";

const initialState = {
    schemeUseage: null,
    loading: null,
    error: null,
};

export const getMerchantUsedSchemeReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
) => {
    switch (action.type) {
        case GET_MERCHANT_USED_SCHEME_LOADING:
            return {
                ...state,
                loading: action.loading,
                error: null,
            };
        case GET_MERCHANT_USED_SCHEME_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                schemeUseage: action.payload,
            };
        case GET_MERCHANT_USED_SCHEME_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case REMOVE_MERCHANT_USED_SCHEME:
            return initialState;

        default:
            return state;
    }
};
